const languages = {
  EN: 'en',
  PT_BR: 'ptBr'
};

module.exports = languages;
